var _path;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgEmail(props, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 14,
    viewBox: "0 0 16 12",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14.5 11.5H1.5C0.673 11.5 0 10.827 0 10V2C0 1.173 0.673 0.5 1.5 0.5H14.5C15.327 0.5 16 1.173 16 2V10C16 10.827 15.327 11.5 14.5 11.5ZM1.5 10.5H14.5C14.7755 10.5 15 10.2755 15 10V2.1585L8.3255 7.8795C8.2315 7.9595 8.116 8 8 8C7.884 8 7.7685 7.9595 7.6745 7.8795L1 2.1585V10C1 10.2755 1.2245 10.5 1.5 10.5ZM14.2315 1.5H1.7685L8 6.8415L14.2315 1.5Z"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmail);
export default __webpack_public_path__ + "assets/media/Email.c4fa95a9.svg";
export { ForwardRef as ReactComponent };